export const deliveryTabViewBuilder = (tabs, offices) => {
  let noOfficesOption = +(offices === 0);
  let unneededOption = 'takeaway';
  if (tabs.length === 1) {
    unneededOption = tabs[0].slug;
    noOfficesOption = 0;
  }
  const tabsToRender = noOfficesOption ? tabs.filter(({ slug }) => slug !== unneededOption) : tabs;

  return {
    tabsToRender,
    redirectOption: noOfficesOption,
  };
};
